import { observer } from 'mobx-react';
import { useStore } from '../../state/MobxContext';
import Box from '@mui/material/Box';
import { Button } from '@mui/material';
import Dialog from '@mui/material/Dialog';
import CloverleafImage from '../Main/image/Cloverleaf.png';
import DialogContent from '@mui/material/DialogContent';
// import { useNavigate } from 'react-router-dom';
import blackWallet from '../Main/image/WalletB.png';
import { TextField } from '@mui/material';
import { makeStyles, useMediaQuery } from "@material-ui/core";
import Dicon from '../Main/image/Icon256.png';
import { Typography } from "@material-ui/core";
import { withStyles } from "@material-ui/core/styles";
import LockImage from '../Main/image/lock.png';
import EtherImage from '../Main/image/2089411.png';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faXmark } from '@fortawesome/free-solid-svg-icons';
import Grid from "@mui/material/Grid/Grid";











function CoinSend() {
    const { loginStore } = useStore();
    const { CoinStore } = useStore();

    // const navigate = useNavigate();

    const useStyles = makeStyles((theme) => ({
        //Dialog
        Dialog: {
            width: '450px',
            height: "560px"
        },
        DialogMobile: {
            height: 'auto',
            width: '80%',
            minWidth: "320px",
            padding: '0'
        },

    }));


    const classes = useStyles();
    const isMobile = useMediaQuery("(max-width: 600px)");
    const StandCount = CoinStore?.GuideStandCoin;
    const UserLockToken = CoinStore?.UserLockToken.lockCount;
    const CommissionEther = CoinStore?.Commission;
    const SendButton = CoinStore?.SendButtonChange;
    const GuideWallet = CoinStore?.GuideWallet;
    const GuideStand = CoinStore?.GuideStand;
    const GuideEtherCoin = CoinStore?.GuideEtherCoin;
    let Guide_clover_allPage_01 = loginStore?.Guide_clover_allPage_01; //지갑주소를 입력해주세요
    let Guide_clover_allPage_02 = loginStore?.Guide_clover_allPage_02; //수량을 입력해 주세요
    let Guide_clover_allPage_03 = loginStore?.Guide_clover_allPage_03; //수수료확인
    let Guide_clover_allPage_05 = loginStore?.Guide_clover_allPage_05; //보내기
    let Guide_clover_dialog_CoinSend_01 = loginStore?.Guide_clover_dialog_CoinSend_01; //My.코인 이체
    let Guide_clover_dialog_CoinSend_02 = loginStore?.Guide_clover_dialog_CoinSend_02; //My. 지갑





    


    const WhiteTextTypography = withStyles({
        root: {
            color: "#FFFFFF",
            fontSize: "1.5rem"


        }
    })(Typography);

    const isCoinSendDialogOpen = loginStore?.isCoinSendDialogOpen;


    return (
        <div>
            <Dialog classes={isMobile ? { paper: classes.DialogMobile } : { paper: classes.Dialog }} maxWidth="xl" open={isCoinSendDialogOpen} onClose={loginStore.setDialogClose()}>
                <Box sx={isMobile ? { display: 'flex', bgcolor: 'black', width: 'auto', maxWidth: '600px', height: '60px', } : { display: 'flex', bgcolor: 'black', width: '100%', maxWidth: '600px', height: '70px', }}>
                    <Grid container item xs={12} sm={12} md={12} lg={12} xl={12} direction='row' justifyContent='space-between' alignItems='center' >
                        <Grid container item xs={11} sm={11} md={11} lg={11} xl={11} alignItems="flex-end"  >
                            <img src={CloverleafImage} width="50" height="50" alt="Cloverleaf" />
                            <WhiteTextTypography > {Guide_clover_dialog_CoinSend_01}</WhiteTextTypography>
                        </Grid>
                        <Grid container item xs={1} sm={1} md={1} lg={1} xl={1}>
                            <FontAwesomeIcon icon={faXmark} color='White' size='2x' onClick={(e) => { loginStore.setDialogClose("CoinSendFalse") }} />
                        </Grid>
                    </Grid>
                </Box>
                <DialogContent >
                    <Grid container item xs={12} sm={12} md={12} lg={12} xl={12} direction='row' justifyContent="center" alignItems="flex-end" >
                        <Grid container item xs={2} sm={1} md={1} lg={1} xl={1} justifyContent="flex-start"  >
                            <img style={{ width: '30px', height: "30px" }} src={blackWallet} alt='blackWallet' />
                        </Grid>
                        <Grid container item xs={10} sm={11} md={11} lg={11} xl={11} justifyContent="flex-start"  >
                            <TextField
                                variant="standard"
                                label={Guide_clover_allPage_01}
                                inputProps={isMobile ? { min: 0, style: { textAlign: 'center', fontSize: 13 } } : { min: 0, style: { textAlign: 'center' } }}
                                fullWidth
                                placeholder={GuideWallet}
                                // onClick={(e)=>{CoinStore.WalletTextclick(e)}}
                                onChange={(e) => { CoinStore.WalletTextValue(e) }}
                            />
                        </Grid>
                    </Grid>
                    <Grid container item xs={12} sm={12} md={12} lg={12} xl={12} direction='row' justifyContent="center" alignItems="flex-end" marginTop='10px' >
                        <Grid container item xs={2} sm={1} md={1} lg={1} xl={1} justifyContent="flex-start"  >
                            <img src={Dicon} style={{ width: '30px', height: "30px" }} alt='DiconImage' />
                        </Grid>
                        <Grid container item xs={10} sm={11} md={11} lg={11} xl={11} justifyContent="flex-start"  >
                            <TextField
                                type='number'
                                variant="standard"
                                label={Guide_clover_allPage_02}
                                inputProps={isMobile ? { min: 0, style: { textAlign: 'center', fontSize: 13 } } : { min: 0, style: { textAlign: 'center' } }}
                                fullWidth
                                placeholder={GuideStand}
                                // onClick={()=>{CoinStore.StandTextclick()}}
                                onChange={(e) => { CoinStore.StandTextValue(e) }}
                            />
                        </Grid>
                    </Grid>
                    <Grid container item xs={12} sm={12} md={12} lg={12} xl={12} direction='row' justifyContent="center" alignItems="flex-end" marginTop='20px' >
                        <Grid container item xs={2} sm={1} md={1} lg={1} xl={1} justifyContent="flex-start"  >
                            <img src={EtherImage} style={{ width: '30px', height: "30px" }} alt='EtherImage' />
                        </Grid>
                        <Grid container item xs={10} sm={11} md={11} lg={11} xl={11} justifyContent="flex-start"  >
                            <TextField
                                disabled
                                variant="standard"
                                // label={CommissionEther}
                                inputProps={isMobile ? { min: 0, style: { textAlign: 'center', fontSize: 10 } } : { min: 0, style: { textAlign: 'center', fontSize: 15 } }}
                                FormHelperTextProps={isMobile ?
                                    { min: 0, style: { textAlign: 'center', fontSize: 10, color: 'red' } } : { min: 0, style: { textAlign: 'center', fontSize: 15, color: 'red' } }}
                                fullWidth
                                value={CommissionEther}
                                helperText={CoinStore?.GuideCommission}
                            />
                        </Grid>
                    </Grid>
                    {/* <Box display="flex" justifyContent="flex-start" alignItems="flex-end" sx={ isMobile ? {marginBottom:'20px', marginLeft: '-20px',}
                : {marginBottom:'20px', marginLeft: '-10px'}} >
                    <img src={Dicon} className={ isMobile ? classes.DiconImageMobile : classes.DiconImage} style={{marginLeft: '10px'}} alt='DiconImage' />
                    <Container style={isMobile ? {marginLeft:'-10px', marginRight: '-15px'} : {marginLeft: '-15px', marginRight: '-25px'}}>
                    <TextField 
                    type='number'
                    variant="standard"
                    label="수량을 입력해 주세요"
                    inputProps={isMobile ? {min: 0, style: { textAlign: 'center',fontSize: 13}} : {min: 0, style: { textAlign: 'center' }} }
                    fullWidth
                    placeholder={GuideStand}
                    // onClick={()=>{CoinStore.StandTextclick()}}
                    onChange={(e) => {CoinStore.StandTextValue(e)}}
                    />
                    </Container>
                </Box> */}
                    {/* <Box display="flex" sx={isMobile ? { height: '5vh', marginTop:'5px', paddingBottom:'20px', marginBottom: '-10px',  marginLeft: '-40px'} 
                : { height: '5vh', marginTop:'5px', paddingBottom:'20px', marginBottom: '-10px'}} >
                    <img src={EtherImage} className={ isMobile ? classes.sendEtherImageMobile : classes.sendEtherImage } alt='EtherImage' />
                    <Container style={isMobile ? {marginLeft:'-10px', marginRight: '-15px'} : {marginLeft: '-10px', marginRight: '-40px'}}>
                    <TextField 
                    disabled
                    variant="standard"
                    // label={CommissionEther}
                    inputProps={isMobile ? {min: 0, style: { textAlign: 'center',fontSize: 10 }} : {min: 0, style: { textAlign: 'center',fontSize: 15 }} }
                    FormHelperTextProps={isMobile ? 
                    {min: 0, style: { textAlign: 'center',fontSize: 10, color:'red' }} : {min: 0, style: { textAlign: 'center',fontSize: 15, color:'red' }} }
                    fullWidth
                    value={CommissionEther}
                    helperText={CoinStore.GuideCommission}
                    />
                    </Container>
                </Box> */}
                    <Grid container item xs={12} sm={12} md={12} lg={12} xl={12} direction='row' justifyContent="flex-start" alignItems="center" marginTop='20px' >
                        <Typography variant={isMobile ? "subtitle1" : "h5"} >{Guide_clover_dialog_CoinSend_02}</Typography>
                    </Grid>
                    {/* <Container style={isMobile ? {marginTop: '-10px',marginLeft: '-20px'} : {marginTop: '10px',marginLeft: '-20px'} }>
                </Container> */}
                    <Box sx={isMobile ? { border: 1, borderRadius: '10px', margin: '-5px', marginTop: '0px' } : { border: 1, borderRadius: '10px', marginTop: '10px' }}>
                        {/* <Box display="flex" justifyContent="flex-start" alignItems="flex-end"  sx={ isMobile ? {marginTop:'20px', marginLeft: '20px'}
                : {marginTop:'20px', marginLeft: '70px'} }>
                    <img src={Dicon} className={ isMobile ? classes.DiconImageMobile : classes.DiconImage} alt='StandImage' />
                    <Container className={ isMobile ? classes.DiconCountLocationMobile : classes.DiconCountLocation }>
                        <Typography variant={ isMobile ? "subtitle1" : "h5" }>.{StandCount !== undefined ? StandCount : '00000000.00000000' }</Typography>
                    </Container>
                </Box>
                <Box display="flex" justifyContent="flex-start" alignItems="center"  sx={ isMobile ? { height: '7vh', marginTop:'-5px', marginLeft: '20px'}
                : { height: '7vh', marginTop:'-5px', marginLeft: '70px'} }>
                    <img className={ isMobile ? classes.LockImageMobile : classes.LockImage } src={LockImage} alt='LockImage' />
                    <Container className={ isMobile ? classes.LockCountLocationMobile : classes.LockCountLocation }>
                        <Typography variant={ isMobile ? "subtitle1" : "h5" }>.{UserLockToken !== undefined ? UserLockToken : '00000000.00000000' }</Typography>
                    </Container>
                </Box>
                <Box display="flex" justifyContent="flex-start" alignItems="center"  sx={ isMobile ? { height: '7vh', marginTop:'-20px', marginLeft: '15px',}
                : { height: '7vh', marginTop:'-20px', marginLeft: '57px'} }>
                    <Container className={ isMobile ? classes.EtherImageLocationMobile : classes.EtherImageLocation }>
                        <img className={ isMobile ? classes.EtherImageMobile : classes.EtherImage } src={EtherImage} alt='EthImage' />
                    </Container>
                    <Container className={ isMobile ? classes.EtherCountLocationMobile : classes.EtherCountLocation }>
                        <Typography variant={ isMobile ? "subtitle1" : "h5" }>.{GuideEtherCoin !== undefined ? GuideEtherCoin : '00000000.00000000' }</Typography>
                    </Container>
                </Box> */}
                        <Grid container item xs={12} sm={12} md={12} lg={12} xl={12} direction='column' justifyContent='center' alignItems='center' >
                            <Grid container item xs={12} sm={12} md={12} lg={12} xl={12} direction='row' justifyContent='center' alignItems='center' marginTop='10px'>
                                <img src={Dicon} style={{ width: '25px', height: "25px" }} alt='DiconImage' />
                                <Typography variant={isMobile ? "subtitle1" : "h5"}>{StandCount !== undefined ? StandCount : '0'}</Typography>
                            </Grid>
                            <Grid container item xs={12} sm={12} md={12} lg={12} xl={12} direction='row' justifyContent='center' alignItems='center' marginTop='10px'>
                                <img style={{ width: '25px', height: "25px" }} src={LockImage} alt='LockImage' />
                                <Typography style={{ fontWeight: 'light' }} variant={isMobile ? "subtitle1" : "h5"}>{UserLockToken !== undefined ? UserLockToken : '0'}</Typography>
                            </Grid>
                            <Grid container item xs={12} sm={12} md={12} lg={12} xl={12} direction='row' justifyContent='center' alignItems='center' marginTop='10px'>
                                <img style={{ width: '25px', height: "25px" }} src={EtherImage} alt='EthImage' />
                                <Typography style={{ fontWeight: 'light' }} variant={isMobile ? "subtitle1" : "h5"}>{GuideEtherCoin !== undefined ? GuideEtherCoin : '0'}</Typography>
                            </Grid>
                            <Grid container item xs={12} sm={12} md={12} lg={12} xl={12} direction='row' justifyContent='center' alignItems='center' marginTop='10px' />
                            <Grid container item xs={12} sm={12} md={12} lg={12} xl={12} direction='row' justifyContent='center' alignItems='center' marginTop='10px' />

                        </Grid>
                    </Box>
                    <Grid container item xs={12} sm={12} md={12} lg={12} xl={12} direction='row' justifyContent='center' alignItems='flex-end' marginTop='25px'>
                        {SendButton === 0 ?
                            <Button variant="contained" size="medium"
                                style={isMobile ? { maxWidth: '100%', maxHeight: '100%', minWidth: '100%', minHeight: '100%', fontSize: 25 }
                                    : { maxWidth: '100%', maxHeight: '100%', minWidth: '100%', minHeight: '100%', fontSize: 25 }} onClick={(e) => { CoinStore.getCommissionEther() }} >{Guide_clover_allPage_03}</Button>
                            :
                            <Button variant="contained" size="medium"
                                style={isMobile ? { maxWidth: '100%', maxHeight: '100%', minWidth: '100%', minHeight: '100%', fontSize: 25 }
                                    : { maxWidth: '100%', maxHeight: '100%', minWidth: '100%', minHeight: '100%', fontSize: 25 }} onClick={(e) => { CoinStore.SandCoin() }} >{Guide_clover_allPage_05}</Button>
                        }
                    </Grid>
                </DialogContent>
                {/* <Box display="flex" justifyContent="space-evenly" alignItems="center" marginBottom='15px' marginTop='-50px' >
                {SendButton === 0 ?
                <Button variant="contained" size="medium" 
                style={ isMobile ? {maxWidth: '230px', maxHeight: '50px', minWidth: '230px', minHeight: '50px',fontSize: 25}
                : {maxWidth: '400px', maxHeight: '50px', minWidth: '400px', minHeight: '50px',fontSize: 25} } onClick={(e) => {CoinStore.getCommissionEther()}} >수수료확인</Button>  
                : 
                <Button variant="contained" size="medium" 
                style={ isMobile ? {maxWidth: '230px', maxHeight: '50px', minWidth: '230px', minHeight: '50px',fontSize: 25}
                : {maxWidth: '400px', maxHeight: '50px', minWidth: '400px', minHeight: '50px',fontSize: 25} } onClick={(e) => {CoinStore.SandCoin()}} >보내기</Button>
                }
            </Box> */}
            </Dialog>
        </div>
    );
};

export default observer(CoinSend);